import { render, staticRenderFns } from "./app-detail-new-relevant-rank-list.vue?vue&type=template&id=c7940670&"
import script from "./app-detail-new-relevant-rank-list.vue?vue&type=script&lang=js&"
export * from "./app-detail-new-relevant-rank-list.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-new-relevant-rank-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports